import Vuex from "vuex";
import Vue from "vue/dist/vue.common";
import $ from "jquery";
import numberFormat from "./lib/numberFormat";
import Modal from "../components/modal/modal";

export const eventBus = new Vue();

export const priceFormat = function(value) {
  return `${numberFormat(value, 0, ",", " ")} ₽`;
};

Vue.use(Vuex);
Vue.filter("price", priceFormat);

const api = "http://localhost:3333";

const state = {
  cart: {
    products: [],
    amount: 0,
    cost: 0
  }
};

const mutations = {
  ADD_PRODUCT(state, product) {
    state.cart.products.push(product);
  },
  REMOVE_PRODUCT(state, id) {
    state.cart.products = state.cart.products.filter(
      product => product.id !== id
    );
  },
  UPDATE_PRODUCTS(state, products) {
    state.cart.products = [...products];
  },
  UPDATE_AMOUNT(state, amount) {
    state.cart.amount = amount;
  },
  UPDATE_COST(state, cost) {
    state.cart.cost = Number(cost);
  }
};

const actions = {
  syncCart({ commit }) {
    return $.ajax({
      url: `/cart/api/`,
      type: "GET"
    })
      .done(({ amount = 0, cost = 0, products = [] }) => {
        commit("UPDATE_COST", cost);
        commit("UPDATE_AMOUNT", amount);
        commit("UPDATE_PRODUCTS", products);

        eventBus.$emit("cart.synced");
      })
      .fail(() => {
        throw new Error();
      });
  },
  addProduct({ state, commit }, { id, amount }) {
    return $.ajax({
      type: "POST",
      url: `/cart/api/add`,
      data: { id, amount }
    })
      .done(({ cost, amount, products = [] }) => {
        const product = products.find(p => p.id === id);

        commit("ADD_PRODUCT", product);
        commit("UPDATE_AMOUNT", amount);
        commit("UPDATE_COST", cost);

        Modal.loadAndOpen({
          url: `/cart/api/modal/`,
          data: { id }
        });

        eventBus.$emit("product.add", { id });

        return product;
      })
      .fail(() => {
        return new Error("Product didnt add");
      });
  },
  removeProduct({ commit }, id) {
    return $.ajax({
      url: `/cart/api/remove`,
      type: "POST",
      data: { id }
    }).done(({ amount, cost }) => {
      commit("REMOVE_PRODUCT", id);
      commit("UPDATE_AMOUNT", amount);
      commit("UPDATE_COST", cost);

      eventBus.$emit("product.remove", { id });

      return id;
    });
  },
  updateProductAmount({ commit }, { id, amount }) {
    return $.ajax({
      url: `/cart/api/update`,
      type: "POST",
      data: { id, amount }
    }).done(({ amount, cost, products }) => {
      commit("UPDATE_COST", cost);
      commit("UPDATE_PRODUCTS", products);

      eventBus.$emit("product.amount.change", { id, amount });

      return id;
    });
  },
  getProduct({ state }, id) {
    return state.cart.products.filter(item => Number(item.id) === id);
  }
};

const getters = {
  products(state) {
    return state.cart.products;
  },
  product(state) {
    return id => state.cart.products.find(item => Number(item.id) === id);
  },
  amount(state) {
    return state.cart.amount;
  },
  cost(state) {
    return state.cart.cost;
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

store.dispatch("syncCart");

export default store;
